
import React, { useState } from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";

// Assets
import cfd_whitepaper from "../pages/cfd_whitepaper.png";
import vmm_whitepaper from "../pages/vmm_whitepaper.jpeg";
import ms_whitepaper from "../pages/ms_whitepaper.png";
import ltc_gif from "../pages/ltc_whitepaper.gif";
import ltc_whitepaper from "../pages/ltc.png";
const TechnicalDocs = () => {
  const [activeProduct, setActiveProduct] = useState("QuantaWind");
  const products = ["QuantaWind"];

  const docs = [
    {
      id: "01",
      category: "QuantaWind",
      link: "/whitepaper/wrf-cfd",
      image: cfd_whitepaper,
      title: "Coupled WRF-CFD Model in QuantaWind",
      description: "Exploring the integration of mesoscale and microscale modeling for precise wind resource assessment.",
    },
    {
      id: "02",
      category: "QuantaWind",
      link: "/whitepaper/vmm",
      image: vmm_whitepaper,
      title: "Virtual Met Mast Methodology",
      description: "Validation frameworks for synthetic data generation in complex terrains and offshore environments.",
    },
    {
      id: "03",
      category: "QuantaWind",
      link: "/whitepaper/micrositing",
      image: ms_whitepaper,
      title: "Micrositing Services in QuantaWind",
      description: "Optimization strategies for turbine placement to maximize annual energy production and reduce wake losses.",
    },
    {
    id: "04",
    category: "QuantaWind",
    link: "/whitepaper/ltc",          // <-- new route
    image: ltc_gif,                  // <-- GIF thumbnail
    title: "Long-Term Correction (LTC) Systems",
    description:
      "Why standard MCP assumptions break down—and how QuantaWind’s physics-aware LTC narrows P50–P90 uncertainty.",
  },
  ];

  const filteredDocs = docs.filter((doc) => doc.category === activeProduct);

  return (
    <React.Fragment>
      <style>
        {`
          :root {
            --primary: #000;
            --brand-blue: #1192EE;
            --text-muted: #666;
          }

          .docs-wrapper {
            background-color: #fff;
            padding: 100px 0 120px 0; 
            font-family: 'Inter', system-ui, -apple-system, sans-serif;
          }

          /* --- ASYMMETRIC HEADER --- */
  /* --- UPDATED HEADER TYPOGRAPHY --- */
.header-container {
  display: flex;
  max-width: 1200px;
  /* Using padding-top to force the gap from the breadcrumb */
  padding: 40px 40px 60px 40px !important; 
  margin: 0 auto !important; 
  align-items: flex-start; /* Changed to start for better text flow */
  gap: 60px;
}

.fancy-title {
  font-size: 50px; /* Increased size */
  font-weight: 900;
  line-height: 1.1; /* More breathing room between words */
  letter-spacing: -2px; /* Less aggressive than -4px for better legibility */
  margin: 0;
  color: var(--brand-blue);
  text-transform: uppercase;
}

.header-side {
  flex: 1;
  font-size: 18px; /* Increased from 14px for high readability */
  color: #444; /* Darker gray for better contrast */
  border-left: 2px solid #eee;
  padding-left: 30px;
  line-height: 1.8; /* Industry standard for readable body text */
  margin-top: 15px;
}

@media (max-width: 991px) {
  .header-container {
    flex-direction: column;
    padding-top: 100px !important;
    gap: 30px;
  }
  .fancy-title {
    font-size: 48px;
  }
  .header-side {
    border-left: none;
    padding-left: 0;
    font-size: 16px;
  }
}

          /* --- PRODUCT SELECTION TABS --- */
          .tabs-container {
            max-width: 1200px;
            margin: 0 auto 0 auto;
            padding: 0 40px;
            display: flex;
            gap: 40px;
            border-bottom: 1px solid #eee;
          }

          .tab-button {
            background: none;
            border: none;
            padding: 20px 0;
            font-size: 14px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 2px;
            color: #999;
            cursor: pointer;
            position: relative;
            transition: color 0.3s ease;
          }

          .tab-button.active { color: var(--brand-blue); }
          .tab-button.active::after {
            content: "";
            position: absolute;
            bottom: -1px;
            left: 0;
            width: 100%;
            height: 3px;
            background-color: var(--brand-blue);
          }

          /* --- CARDS LAYOUT --- */
          .cards-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 40px;
          }

          .doc-item {
            display: flex;
            align-items: center;
            gap: 60px;
            padding: 80px 40px; 
            margin: 30px -40px;
            border-bottom: 1px solid #eee; 
            text-decoration: none;
            color: inherit;
            transition: all 0.5s cubic-bezier(0.2, 1, 0.3, 1);
            border-radius: 12px;
          }

          .doc-item:hover { background-color: #fafafa; }
          .doc-item:hover .doc-img-wrapper { transform: scale(1.02); }

          .doc-index {
            font-size: 16px;
            font-weight: 700;
            color: var(--brand-blue);
            align-self: flex-start;
          }

          .doc-content { flex: 1; }

          .doc-content h3 {
            font-size: 32px;
            font-weight: 700;
            margin: 10px 0 20px 0;
            letter-spacing: -1px;
            line-height: 1.2;
          }

          .doc-content p {
            font-size: 18px;
            color: var(--text-muted);
            max-width: 500px;
            line-height: 1.6;
          }

          .doc-img-wrapper {
            flex: 1;
            height: 350px;
            overflow: hidden;
            border-radius: 4px;
            transition: transform 0.6s ease;
            box-shadow: 0 30px 60px -12px rgba(0,0,0,0.12);
          }

          .doc-img-wrapper img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          /* --- RESPONSIVE FIXES (FROM OLD VERSION) --- */
          @media (max-width: 991px) {
            .fancy-title { font-size: 40px; }
            .header-container { 
               flex-direction: column; 
               align-items: flex-start; 
               margin-top: 50px !important; 
               gap: 20px;
            }
            .header-side { border-left: none; padding-left: 0; }
            
            .tabs-container { 
               gap: 20px; 
               overflow-x: auto; /* Allow tabs to scroll on tiny screens */
               white-space: nowrap;
            }

            .doc-item { 
               flex-direction: column; 
               align-items: flex-start; 
               gap: 30px; 
               margin: 20px 0; /* Reset negative margins on mobile */
               padding: 40px 20px; 
            }
            .doc-img-wrapper { width: 100%; height: 250px; }
          }

          /* --- CTA LINK --- */
          .cta-link {
            display: inline-flex;
            align-items: center;
            margin-top: 35px;
            font-weight: 700;
            text-transform: uppercase;
            font-size: 13px;
            letter-spacing: 2px;
            color: var(--primary);
            position: relative;
            padding-bottom: 6px;
          }

          .cta-link::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 40px;
            height: 2px;
            background-color: var(--brand-blue);
            transition: width 0.4s ease;
          }

          .cta-icon {
            margin-left: 10px;
            color: var(--brand-blue);
            transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            display: flex;
            align-items: center;
          }

          .doc-item:hover .cta-link::after { width: 100%; }
          .doc-item:hover .cta-icon { transform: translateX(8px); }

          .empty-state {
            padding: 80px 0;
            text-align: center;
            color: #bbb;
            font-size: 14px;
            letter-spacing: 2px;
            text-transform: uppercase;
            font-weight: 600;
          }
        `}
      </style>

      <SEO title="Technical Documentation | Tawanai" />
      <Header />

      <Breadcrumb
        image="images/bg/bg1.webp"
        title="Resources"
        content="Home"
        contentTwo="Resources"
      />

      <section className="docs-wrapper">
        <div className="header-container">
          <div className="header-main">
            <h1 className="fancy-title">Technical<br />Archives</h1>
          </div>
       
          <div className="header-side">
            A definitive repository of technical whitepapers, analytical studies, and
            validation frameworks establishing the global standards for precision
            modeling and micrositing optimization.
          </div>
        </div>

        <div className="tabs-container">
          {products.map((product) => (
            <button
              key={product}
              className={`tab-button ${activeProduct === product ? "active" : ""}`}
              onClick={() => setActiveProduct(product)}
            >
              {product}
            </button>
          ))}
        </div>

        <div className="cards-container">
          {filteredDocs.length > 0 ? (
            filteredDocs.map((item, index) => (
              <a
                href={item.link}
                key={index}
                className="doc-item"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="doc-index">{item.id}</div>
                <div className="doc-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <div className="cta-link">
                    Read Technical Document
                    <span className="cta-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="doc-img-wrapper">
                  <img src={item.image} alt={item.title} />
                </div>
              </a>
            ))
          ) : (
            <div className="empty-state">Documentation coming soon for {activeProduct}</div>
          )}
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default TechnicalDocs;